<template>
  <div class="yxtbiz-qs-random">
    <yxt-button size="large" type="primary" @click="handleClick">
      <!--   快速抽题   -->
      {{ $t('pc_biz_ote_lbl_quickques')
      }}<yxt-svg
        class="v-mid ml4 mb2"
        width="14px"
        height="14px"
        :icon-class="handleClickVal ? 'arrow-up' : 'arrow-down'"
      />
    </yxt-button>
    <div v-show="handleClickVal" class="yxtbiz-qs-random__content">
      <div v-loading="loadingBtn">
        <div class="yxtbiz-qs-random__line yxtbiz-qs-random__line-bgColor">
          <span class="yxtbiz-qs-random__line-span pl0-i">{{
            $t('pc_biz_ote_lbl_questiontype')
          }}</span>
          <span class="yxtbiz-qs-random__line-span-input pl0-i">{{
            $t(QUES_LEVEL_NAMES[0])
          }}</span>
          <span class="yxtbiz-qs-random__line-span-input pl0-i">{{
            $t(QUES_LEVEL_NAMES[1])
          }}</span>
          <span class="yxtbiz-qs-random__line-span-input pl0-i">{{
            $t(QUES_LEVEL_NAMES[2])
          }}</span>
        </div>
        <div
          v-for="(item, index) in quesList"
          :key="index"
          class="yxtbiz-qs-random__line mt4"
        >
          <span class="yxtbiz-qs-random__line-span">{{ item.type }}</span>
          <span class="yxtbiz-qs-random__line-span-input"
            ><yxt-input-number
              v-model="item.num1"
              controls-position="right"
              class="yxtbiz-qs-random__input-number"
              :min="0"
              :max="quesMaxInut(item.val[0])"
              size="mini"
              :step="1"
              step-strictly
            ></yxt-input-number>
            ≤ {{ quesMaxMethod(item.val[0]) }}</span
          >
          <span class="yxtbiz-qs-random__line-span-input"
            ><yxt-input-number
              v-model="item.num2"
              controls-position="right"
              class="yxtbiz-qs-random__input-number"
              :min="0"
              :max="quesMaxInut(item.val[1])"
              size="mini"
              :step="1"
              step-strictly
            ></yxt-input-number>
            ≤ {{ quesMaxMethod(item.val[1]) }}</span
          >
          <span class="yxtbiz-qs-random__line-span-input"
            ><yxt-input-number
              v-model="item.num3"
              controls-position="right"
              class="yxtbiz-qs-random__input-number"
              :min="0"
              :max="quesMaxInut(item.val[2])"
              size="mini"
              :step="1"
              step-strictly
            ></yxt-input-number>
            ≤ {{ quesMaxMethod(item.val[2]) }}</span
          >
        </div>
      </div>
      <yxt-row class="yxtbiz-qs-random__select-btn mt16">
        <yxt-button plain :disabled="loadingBtn" @click="handleCancel">{{
          $t('pc_biz_ote_btn_cancle')
        }}</yxt-button>
        <yxt-button
          type="primary"
          :disabled="loadingBtn"
          @click="handleConfirm"
        >
          {{ $t('pc_biz_ote_btn_screen') }}
        </yxt-button>
      </yxt-row>
    </div>
  </div>
</template>

<script>
import * as examService from '../service';
import { QUES_TYPE_NAMES, QUES_LEVEL_NAMES, handleError } from '../utils';

export default {
  name: 'randomSelect',
  props: {
    quesTypes: {
      type: Array,
      default: []
    },
    pointIds: {
      default() {
        return [];
      },
      type: Array
    }
  },
  data() {
    this.watchDocument = e => {
      let quesDom = document.querySelector('.yxtbiz-qs-random')
        ? document.querySelector('.yxtbiz-qs-random').innerHTML
        : '';
      if (e.target.innerHTML.includes(quesDom)) {
        this.handleClickVal = false;
        document.removeEventListener('click', this.watchDocument);
      }
    };
    return {
      QUES_LEVEL_NAMES,
      loadingBtn: false, // 按钮loading
      handleClickVal: false, // 打开弹框
      quesList: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    handleError,
    quesMaxInut(val) {
      return val >= 1000 ? 999 : val;
    },
    quesMaxMethod(val) {
      return val >= 1000 ? '999+' : val;
    },
    init() {
      this.quesList = this.quesTypes.map(e => {
        return {
          type: this.$t(QUES_TYPE_NAMES[e]),
          quesType: e,
          val: [0, 0, 0],
          num: [],
          num1: 0,
          num2: 0,
          num3: 0
        };
      });
    },
    handleCancel() {
      this.handleClickVal = false;
      this.watchDocumentChange();
    },
    getTypeSet(t) {
      const typeSet = this.quesList.find(ts => {
        return ts.quesType === t;
      });
      return (
        typeSet || {
          type: '',
          val: [0, 0, 0],
          num: [],
          num1: 0,
          num2: 0,
          num3: 0
        }
      );
    },
    handleConfirm() {
      this.loadingBtn = true;
      let quickChoice4GetList = [];
      for (let i = 0; i < 3; i++) {
        quickChoice4GetList.push({
          singleQty: this.getTypeSet(0)['num' + (i + 1)],
          multiQty: this.getTypeSet(1)['num' + (i + 1)],
          judgeQty: this.getTypeSet(2)['num' + (i + 1)],
          fillQty: this.getTypeSet(3)['num' + (i + 1)],
          qaQty: this.getTypeSet(4)['num' + (i + 1)],
          compositeQty: this.getTypeSet(5)['num' + (i + 1)],
          levelType: i
        });
      }
      examService
        .getQuesChoiceQuestion({
          pointIds: this.pointIds,
          quickChoice4GetList
        })
        .then(res => {
          this.loadingBtn = false;
          this.handleClickVal = false;
          this.$emit('setQuestion', res);
        })
        .catch(err => {
          this.loadingBtn = false;
          this.handleError.bind(this)(err);
        });
    },
    handleClick() {
      if (this.pointIds.length === 0) {
        this.$message.warning(this.$t('pc_biz_ote_msg_selqueslib'));
        return;
      }
      this.handleClickVal = !this.handleClickVal;
      this.watchDocumentChange();
      this.loadingBtn = true;
      if (!this.handleClickVal) {
        this.loadingBtn = false;
        return;
      }
      examService
        .getQuesChoiceQty(this.pointIds)
        .then(res => {
          this.init();
          this.loadingBtn = false;
          if (res.length < 3) {
            for (let i = 0; i < 3; i++) {
              if (!res[i] || res[i].levelType !== i) {
                res.splice(i, 0, {
                  levelType: i,
                  singleMaxQty: 0,
                  multiMaxQty: 0,
                  judgeMaxQty: 0,
                  fillMaxQty: 0,
                  qaMaxQty: 0,
                  compositeMaxQty: 0
                });
              }
            }
          }
          let arr = [
            'singleMaxQty',
            'multiMaxQty',
            'judgeMaxQty',
            'fillMaxQty',
            'qaMaxQty',
            'compositeMaxQty'
          ]; // Max选题
          this.quesList.forEach((item, index) => {
            const t = item.quesType;
            [0, 1, 2].forEach(e => {
              item.val[e] = res[e][arr[t]];
            });
          });
        })
        .catch(err => {
          this.loadingBtn = false; // 关闭loading
          this.handleError.bind(this)(err);
        });
    },
    watchDocumentChange() {
      if (this.handleClickVal) {
        document.addEventListener('click', this.watchDocument);
      } else {
        document.removeEventListener('click', this.watchDocument);
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.watchDocument);
  }
};
</script>
